<mat-form-field class="w-full">
  <mat-label>TA-Direct object ID</mat-label>
  <input
    [attr.aria-label]="ariaInput"
    [formControl]="controlForm"
    matInput
    type="text"
  />
  @if (loadingValidation > 0) {
    <mat-spinner
      [attr.aria-label]="ariaLoading"
      class="mx-[12px]"
      matSuffix
      [diameter]="24"
    ></mat-spinner>
  }
  @if (controlForm.hasError('invalidID')) {
    <mat-error><small>Invalid TA-Direct object ID</small></mat-error>
  } @else if (controlForm.hasError('required')) {
    <mat-error><small>Required field</small></mat-error>
  }
</mat-form-field>
